import { combineReducers } from 'redux'

import mission from './mission/reducers'
import otuVision from './otuVision/reducers'
import workoutTogether from './workoutTogether/reducers'
import gym from './gym/reducers'
import team from './team/reducers'
import classrooms from './classrooms/reducers'
import licenses from './licenses/reducers'
import notifications from './notifications/reducers'
import fundraiser from './fundraiser/reducers'
import translate from './translate/reducers'
import broadcasts from './broadcasts/reducers'
import demo from './demo/reducers'





const reducers = combineReducers({
  mission,
  otuVision,
  workoutTogether,
  gym,
  team,
  classrooms,
  licenses,
  notifications,
  fundraiser,
  translate,
  broadcasts,
  demo
})

export default reducers